import { render, staticRenderFns } from "./BoardSettingsWidget.vue?vue&type=template&id=beb9e924&scoped=true&lang=pug&"
import script from "./BoardSettingsWidget.vue?vue&type=script&lang=js&"
export * from "./BoardSettingsWidget.vue?vue&type=script&lang=js&"
import style0 from "./BoardSettingsWidget.vue?vue&type=style&index=0&id=beb9e924&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb9e924",
  null
  
)

export default component.exports